/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import template from './supporting-pages-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-supporting-pages-page',
  template
})
export class SupportingPagesPageComponent {
  readonly showAdnInvoicing: boolean;
  readonly showNetworkOverview: boolean;

  constructor(@Inject(LocalUserProfile) localUserProfile: LocalUserProfile, private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()) {
    this.showAdnInvoicing = localUserProfile.isSpecialUser();
    this.showNetworkOverview = localUserProfile.isSpecialUser();
  }

  clearTheme(): void {
    this.localNetworkInfo.clearSuppInfo();
  }
}
